import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { MQ_TASK } from '@iarc-programing/emanufac-constant';
import { Button, Card, CardContent } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';

import * as actions from '@/redux/actions';
import { MANUFACTURING_TRANSACTION_TYPE } from '@/utils/constants';

import CardDeliveryInProcess from '../../Card/CardDeliveryInProcess';
import CardDeposit from '../../Card/CardDeposit';
import SocketIOLoading from '../../Loading/SocketIOLoading';
import { CancleProcessModal } from '../../Modals';
import { ProcessReport } from '../../Report';
import { BrachingStepTimeline, TimelineStepper } from '../../Timeline';
import AllMaterialUsageCard from '../Material/AllMaterialUsageCard';
import BoxPreferMaterial from '../Material/BoxPreferMaterial';
import BoxRemainingMaterial from '../Material/BoxRemainingMaterial';
import MaterialSourceBox from '../Material/MaterialSourceBox';
import BoxResultingFunction from '../MMS/BoxResultingFunction';
import CommentBox from '../MMS/CommentBox';
import ManufacTransactionBox from '../MMS/ManufacTransactionBox';
import MeasurementVariableListBox from '../MMS/MeasurementVariableListBox';
import StepTimeBox from '../MMS/StepTimeBox';
import ProductAsMaterialResultBox from '../Product/ProductAsMaterialResultBox';
import ProductResultBox from '../Product/ProductResultBox';
import PluginDisplayRenderingComponent from '../Rendering/PluginDisplayRenderingComponent';

import ProcessControlBox from './ProcessControlBox';
import ProcessDetailBox from './ProcessDetailBox';
import ProcessNoInfoBox from './ProcessNoInfoBox';
import ProcessStartTimeBox from './ProcessStartTimeBox';
import ProcessStatusBox from './ProcessStatusBox';

const ProcessActionContainerBox = ({
  selectedProcess,
  manufacturingOrder,
  getManufacturingOrder = () => {},
  referenceNumber,
  setDialogLoadingOpen,
}) => {
  const [modalCancleProcessOpen, setModalCancleProcessOpen] = useState(false);
  const me = useSelector((state) => state.me);
  const information = useSelector((state) => state.information);

  const dispatch = useDispatch();

  const handleCancleProcess = () => {
    setModalCancleProcessOpen(true);
  };

  const handlePrint = () => {
    try {
      ProcessReport(selectedProcess, manufacturingOrder, information);
    } catch (error) {
      window.alert(`Error on Print ${error?.message}`);
      ProcessReport(selectedProcess, manufacturingOrder, information, true);
    }
  };

  const reportList = _.filter(
    information?.setting?.mms?.customReport,
    (each) =>
      each?.is_process_level === true &&
      each?.process_template === selectedProcess?.process_template,
  );
  const handleDeleteProcess = async (data) => {
    const { delete_note = '' } = data;
    try {
      setModalCancleProcessOpen(false);
      await dispatch(
        actions.processPut(selectedProcess?._id, {
          deleted: true,
          employeeId: me?.userData?._id,
          delete_note,
          referenceNumber,
          manufacturing_transaction_type:
            MANUFACTURING_TRANSACTION_TYPE.PROCESS_CANCLE.status_code,
        }),
      );
      setDialogLoadingOpen(true);
    } catch (error) {
      console.error('Error on Cancle Process', error);
      window.alert(`ยกเลิกไลน์การผลิตไม่สำเร็จ ${error?.message}`);
    }
  };

  const handleSocketIOFunction = {
    onFail: (args) => {
      setDialogLoadingOpen(false);
      Swal.fire({
        icon: 'error',
        title: 'ไม่สามารถสร้างคำสั่งผลิตได้',
        text: args?.message,
      });
    },
    onSuccess: (args) => {
      setDialogLoadingOpen(false);
      Swal.fire({
        icon: 'success',
        title: 'ดำเนินการสำเร็จแล้ว',
      });
      getManufacturingOrder();
    },
  };
  return (
    <div className="my-2">
      <CancleProcessModal
        isOpen={modalCancleProcessOpen}
        handleClose={() => setModalCancleProcessOpen(false)}
        selectedProcess={selectedProcess}
        manufacturingOrder={manufacturingOrder}
        successHandle={(data) => {
          handleDeleteProcess(selectedProcess, data);
        }}
      />
      <SocketIOLoading
        referenceNumber={referenceNumber}
        taskCode={MQ_TASK.UPDATE_PROCESS.status_code}
        handleFail={handleSocketIOFunction.onFail}
        handleSuccess={handleSocketIOFunction.onSuccess}
        setStatusMessage={() => {}}
      />
      <div className="my-2">
        <ProcessNoInfoBox
          me={me}
          selectedProcess={selectedProcess}
          information={information}
          handleCancle={handleCancleProcess}
          handlePrint={handlePrint}
        />
      </div>
      <Card className="my-2">
        <CardContent>
          <div className="w-full">
            {_.includes(
              _.map(selectedProcess?.steps, (each) => each?.splited_step),
              true,
            ) ? (
              <BrachingStepTimeline
                processSteps={selectedProcess?.steps}
                allowDrag={false}
                currentProcess={selectedProcess}
              />
            ) : (
              <TimelineStepper
                information={information}
                selectedProcess={selectedProcess}
              />
            )}
          </div>
          <div className="my-2 pt-4">
            <ProcessControlBox
              currentStep={selectedProcess?.current?.step}
              process={selectedProcess}
              justify="center"
              container={false}
            />
          </div>
        </CardContent>
      </Card>
      <PluginDisplayRenderingComponent
        currentProcess={selectedProcess}
        currentStep={selectedProcess?.current?.step}
        manufacturingOrder={manufacturingOrder}
      />
      <div className="flex flex-wrap mt-4 my-2">
        <div className="w-full lg:w-1/2 xl:w-1/3 px-1">
          {(information?.setting?.mms?.process?.addDeposit ||
            information?.setting?.mms?.manufacturingOrder?.addDeposit) && (
            <CardDeposit currentProcess={selectedProcess} />
          )}
          <Card>
            <CardContent>
              <h4 className="font-bold font-display">วัตถุดิบ</h4>
              {selectedProcess?.isRequestMaterial ? (
                <BoxRemainingMaterial
                  manufacturingMaterials={
                    selectedProcess.manufacturing_materials
                  }
                  selectedProcess={selectedProcess}
                />
              ) : (
                <BoxPreferMaterial
                  processMaterialList={selectedProcess?.materials}
                />
              )}
            </CardContent>
          </Card>
          {(selectedProcess?.delivery?.delivered ||
            selectedProcess?.delivery?.used_to_delivered ||
            selectedProcess?.delivery?.delivery_method) && (
            <CardDeliveryInProcess selectedProcess={selectedProcess} />
          )}
        </div>
        <div className="w-full  lg:w-1/2 xl:w-1/3 mt-2 lg:mt-0 px-1">
          <Card>
            <CardContent>
              <ProcessStatusBox selectedProcess={selectedProcess} />
            </CardContent>
          </Card>{' '}
          <Card className="my-2">
            <CardContent>
              <ProcessDetailBox selectedProcess={selectedProcess} />
              {!_.isEmpty(reportList) && (
                <div className="font-semibold  font-display my-2">รายงาน</div>
              )}
              {_.map(reportList, (eachCReport, idx) => (
                <Link
                  to={{
                    pathname: '/mms/manufacturing-orders/report',
                    state: {
                      manufacturingOrder,
                      selectedProcess,
                      report: eachCReport,
                    },
                  }}
                  key={idx}
                >
                  <Button variant="outlined">{eachCReport?.name}</Button>
                </Link>
              ))}
            </CardContent>
          </Card>
          <Card className="my-2">
            <CardContent>
              <ProcessStartTimeBox
                selectedProcess={selectedProcess}
                manufacturingOrder={manufacturingOrder}
              />
            </CardContent>
          </Card>
          <Card className="my-2">
            <CardContent>
              <h4 className="font-bold font-display">ระยะเวลาทำงาน</h4>
              <StepTimeBox
                selectedProcess={selectedProcess}
                manufacturingTransaction={{
                  rows: selectedProcess?.manufacturing_transactions,
                }}
              />
            </CardContent>
          </Card>
        </div>
        <div className="  w-full lg:w-1/2 xl:w-1/3 mt-2 lg:mt-2 xl:mt-0 px-1">
          <Card>
            <CardContent>
              <h4 className="font-bold font-display">Timeline การผลิต</h4>
              <ManufacTransactionBox
                manufacturingTransaction={{
                  rows: selectedProcess?.manufacturing_transactions,
                }}
                showTitle={false}
                container={false}
              />
            </CardContent>
          </Card>
        </div>
      </div>
      {!_.isEmpty(selectedProcess?.measurement_type_data) && (
        <Card className="my-2">
          <CardContent>
            <h4 className="font-bold font-display">ค่าที่วัดผล</h4>
            <div className="w-full mt-2">
              <MeasurementVariableListBox selectedProcess={selectedProcess} />
            </div>
          </CardContent>
        </Card>
      )}
      {!_.isEmpty(selectedProcess?.resulting_function_types) && (
        <Card className="my-2">
          <CardContent>
            <h4 className="font-semibold font-display">ผลจากการวัด</h4>
            <BoxResultingFunction
              currentProcess={selectedProcess}
              currentStepIndex={selectedProcess?.current?.index}
            />
          </CardContent>
        </Card>
      )}

      {/* <Card>
          <CardContent>
            <h4 className="font-semibold font-display"> กระบวนการทำงาน</h4>
            <div className="flex flex-wrap justify-center ">
              {!_.isEmpty(selectedProcess?.steps) && (
                <div className="w-full lg:w-1/3">
                  <StepEmployee steps={selectedProcess?.steps} />
                </div>
              )}
            </div>
          </CardContent>
        </Card> */}
      <div className="flex flex-wrap my-2">
        <div className="w-full lg:w-1/2 xl:w-1/3 px-1">
          <Card className="my-2">
            <CardContent>
              <div className="flex justify-between items-center">
                <div className="font-semibold font-display">ผลผลิต</div>
                <div>
                  {information?.external_software?.ewarehouse?.enable && (
                    <Link
                      to={`/mms/process/product-barcode/${selectedProcess?._id}`}
                    >
                      <Button size="small">พิมพ์บาร์โค้ด</Button>
                    </Link>
                  )}
                </div>
              </div>
              <ProductResultBox
                information={information}
                selectedProcess={selectedProcess}
              />
              <ProductAsMaterialResultBox
                information={information}
                selectedProcess={selectedProcess}
              />
            </CardContent>
          </Card>
        </div>
        <div className="w-full lg:w-1/2 xl:w-1/3 px-1">
          <Card className="my-2">
            <CardContent>
              <div className="font-semibold font-display">การใช้วัตถุดิบ</div>
              <AllMaterialUsageCard selectedProcess={selectedProcess} />
            </CardContent>
          </Card>
        </div>{' '}
        <div className="w-full lg:w-1/2 xl:w-1/3 px-1">
          <Card className="my-2">
            <CardContent>
              <div className="font-semibold font-display">ที่มาวัตถุดิบ</div>
              <MaterialSourceBox
                selectedProcess={selectedProcess}
                information={information}
              />
            </CardContent>
          </Card>
        </div>
        <div className="w-full">
          <Card>
            <CardContent>
              <h4 className="font-semibold font-display"> ความคิดเห็น</h4>
              <CommentBox
                comment={{ rows: selectedProcess?.comments }}
                processId={selectedProcess?._id}
                showTitle={false}
                container={false}
                handleSuccess={getManufacturingOrder}
              />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ProcessActionContainerBox;

ProcessActionContainerBox.propTypes = {
  selectedProcess: PropTypes.object,
  manufacturingOrder: PropTypes.object,
  getManufacturingOrder: PropTypes.func,
  referenceNumber: PropTypes.string,
  setDialogLoadingOpen: PropTypes.func,
};
